<template>
    <div class="p-col-12">
        <div class="card">
            <page-header title="dataTable.client.title" :actions="pageActions"/>
            <ancestryline-data-table :data-function="dataFunction" :columns="columns" :default-filter="filters" ref="clientlistdatatable"/>
        </div>
    </div>
</template>

<script>
    import AncestrylineDataTable from "@/components/table/AncestrylineDataTable";
    import FrontBusiness from "@/business/FrontBusiness";
    import PageHeader from "@/components/page/PageHeader";
    import DialogService from "@/business/ModalBusiness";
    import Audit from "@/viewer/user/Audit";
    import ClientBusiness from "@/business/ClientBusiness";
    import ToastMessageBusiness from "@/business/ToastMessageBusiness";
    import AncestrylineConfirmation from "@/components/dialog/AncestrylineConfirmation";
    import ModalClientFilter from "@/viewer/client/ModalClientFilter";

    export default {
        name: "ClientList",
        components: {PageHeader, AncestrylineDataTable},

        data() {
            return {
                filters: {
                  name: null,
                },
                dataFunction: ClientBusiness.pagination,
                columns: [
                    {field: "name", header: 'dataTable.client.columns.name', sortable:true, type: 'actions',
                      actions: [
                        {type: "clientLink", title: 'dataTable.client.columns.name'},
                      ]
                    },
                    {field: "document", header: 'dataTable.client.columns.document', sortable:true},
                    {field: "email", header: 'dataTable.client.columns.email', sortable:true},
                    {field: "birthDay", header: 'dataTable.client.columns.birthDay', sortable:true, type: 'date'},
                    {field: "actions", header: 'dataTable.actions', sortable:false, type: 'actions', style: 'width: 100px',
                        actions: [
                            {icon: 'pi pi-user-edit', title: 'dataTable.client.columns.edit', function: this.editClient},
                            {icon: 'pi pi-trash', title: 'dataTable.client.columns.delete', function: this.deleteClient, refreshList: true},
                        ]
                    },
                ],
                pageActions: [
                    {icon: 'pi pi-filter', label: 'dataTable.client.filters', function: this.openFilterModal, type: 'button'},
                    {icon: 'pi pi-user-plus', label: 'dataTable.client.add', url: '/client'},
                    // {icon: 'pi pi-eye', label: 'audit.button-list', function: this.openModal, type: 'button'},
                ],
            }
        },

        methods: {

            editClient(client){
                FrontBusiness.redirect(`/client/${client.id}`);
            },

            async deleteClient(client, dataList){
              if(await DialogService.openConfirmationModal(AncestrylineConfirmation)){
                const response = await ClientBusiness.delete(client.id).catch((e) => {
                  if(e.client_constraint){
                    ToastMessageBusiness.showError(e.client_constraint)
                  } else {
                    ToastMessageBusiness.showError(e.message)
                  }
                });
                if(response){
                  dataList = dataList.filter(c => c.id !== client.id);
                  ToastMessageBusiness.showSuccess();
                }
                return dataList;
              }
            },

            openModal(){
                DialogService.openModal(Audit, {business: ClientBusiness});
            },

            async openFilterModal(){
              const filters = await DialogService.openModal(ModalClientFilter, {filters: this.filters});
              if(filters){
                this.$set(this.$refs.clientlistdatatable, 'filters', filters)
                this.$set(this, 'filters', filters)
                await this.$refs.clientlistdatatable.loadPage()
              }
            },

        }

    }
</script>

<style scoped>

</style>
